const data = {
  counterText: 'வரையறுக்கப்பட்ட இடங்கள் உள்ளன',
  loading: 'ஏற்றுகிறது',
  next: 'அடுத்தது',
  previous: 'முந்தைய',
  smCounterText: 'வரையறுக்கப்பட்ட இடங்கள் மீதமுள்ளன',
};

export default data;
